import React from "react";
import { Field, FieldArray, Form } from "formik";
import Input from "../../../components/inputs/Input";
import { useLocalizeStateValue } from "../../../languages/Localize";
import styled from "styled-components";

const StyledForm = styled(Form)``;

const AttendersForm = props => {
    const { strings } = useLocalizeStateValue();
    const { formData, handleChange, handleBlur, isValid, setFieldTouched, onValidityChange, submitCount } = props;

    const handleFormSubmit = e => {
        e.preventDefault();
    };

    const onChangeHandler = e => {
        handleChange(e);
        setFieldTouched(e.target.name, true, false);
    };

    const onBlurHandler = (index, e) => {
        handleBlur(e);
        props.onFormChange({ attender: e.target.value }, index);
    };

    /* eslint-disable */
    React.useEffect(() => {
        onValidityChange(isValid);
    }, [isValid]);
    /* eslint-enable */

    return (
        <StyledForm className="form-container" onSubmit={handleFormSubmit}>
            <FieldArray
                name="attenders"
                render={() => (
                    <>
                        {formData.attenders.map((item, index) => (
                            <Field key={`attenders.${index}.attender`} name={`attenders.${index}.attender`}>
                                {props => (
                                    <Input
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler.bind(null, index)}
                                        label={`${index + 1}. ${strings.register.attendersForm.attender}`}
                                        submitCount={submitCount}
                                        hasFeedback
                                        {...props}
                                    />
                                )}
                            </Field>
                        ))}
                    </>
                )}
            />
        </StyledForm>
    );
};

export default AttendersForm;
